import { render, staticRenderFns } from "./ArticleContentView.vue?vue&type=template&id=6660da54"
import script from "./ArticleContentView.vue?vue&type=script&lang=js"
export * from "./ArticleContentView.vue?vue&type=script&lang=js"
import style0 from "./ArticleContentView.vue?vue&type=style&index=0&id=6660da54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports